// Using RouterContext directly is not supported by react-router, but using it here as a bit of a hack;
// We are in an inbetween place where react-router doesn't support React Hooks yet, so normally the
// only way to get to the `history` object is using the `withRouter` HOC, but we aren't in a react component, so...
// Once react-router supports hooks, we should be able to remove this and replace it with a `useRouter` hook
// that comes from `react-router` directly.

import React from 'react';
import {__RouterContext as RouterContext} from 'react-router';

export default function useRouter() {
  const routerContext = React.useContext(RouterContext);
  return routerContext;
}
